import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.step,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, { value: "default" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "d-flex pb-2 pr-2",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    label: "Rechercher",
                    outlined: "",
                    "hide-details": "",
                    density: "compact",
                    "append-inner-icon": "$search",
                    clearable: "",
                    "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                subheader: "",
                style: {"height":"40vh","overflow":"scroll"},
                lines: "two"
              }, {
                default: _withCtx(() => [
                  (!_ctx.stockProducts.length && !_ctx.search)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Aucun Produit ajouté ")
                      ], 64))
                    : (!_ctx.filteredStockProducts.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Aucun résultat pour cet produit ")
                        ], 64))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredStockProducts, (product, i) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: i,
                            class: "mt-1 oss-list-item",
                            style: {"background":"#fff"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString((product.title ? product.title + " - " : "") + product.reference), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}